import { render, staticRenderFns } from "./Taxability.vue?vue&type=template&id=f8128cc0&scoped=true&"
import script from "./Taxability.vue?vue&type=script&lang=ts&"
export * from "./Taxability.vue?vue&type=script&lang=ts&"
import style0 from "./Taxability.vue?vue&type=style&index=0&id=f8128cc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8128cc0",
  null
  
)

export default component.exports